import { Box, Center, Flex, Stack, Text } from "@chakra-ui/react";
import Icon from "@modules/Icon";
import React, { memo } from "react";
import { BuildFlagLogo } from "../style";
import AwardCert from "./AwardCert";
import ResponsiveContainer from "./ResponsiveContainer";

interface Props {}
const BuildFlag: React.FC<Props> = () => {
  return (
    <Box>
      <AwardCert />
      <Box bg={"grey100"} py={12}>
        <ResponsiveContainer>
          <Center>
            <Stack direction={{ base: "column", md: "row" }}>
              <Center mr={{ base: 0, md: 5 }}>
                <BuildFlagLogo>
                  <Icon name="flag" />
                </BuildFlagLogo>
              </Center>
              <Box>
                <Flex height="100%" alignItems="center" justifyContent="center">
                  <Text textStyle={"h3"}>
                    Proudly designed & built in the USA
                  </Text>
                </Flex>
              </Box>
            </Stack>
          </Center>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default memo(BuildFlag);
